import React from 'react';
import "../../../styles/Kapcsolat.css"
import BackButtonPage from '../../../components/BackButtonPage';


function Kapcsolat() {
    return (
        <>


            <div className='page-content-container'>
                <div className='kapcsolat-text-container'>
                    <p>
                        Az Egy hajóban projekt kezelője a Salina Alapítvány.
                    </p>
                    <p>
                        Címünk: 2457, Adony, Dajai út 1908
                    </p>
                    <p>
                        Facebook oldalunk: 
                        {/* <Link to={{ pathname: "https://www.facebook.com/EgyHajobanEvezunk" }} className='facebook-link' target="_blank" >
                            https://www.facebook.com/EgyHajobanEvezunk
                        </Link> */}
                        <a 
                        target='_blank' 
                        rel='noopener noreferrer' 
                        href="https://www.facebook.com/EgyHajobanEvezunk"
                        className='facebook-link'
                        >
                            https://www.facebook.com/EgyHajobanEvezunk
                        </a>
                    </p>
                    <p>
                        Képviselő neve: Magyar Attila
                    </p>
                    <p>
                        E-mail címünk: info@emesepark.hu
                    </p>
                    <p>
                        Telefonszámunk: +36 30 9610 212
                    </p>
                    
                </div>
                <BackButtonPage to="/magunkrol" />
            </div>


        </> 
    );
}

export default Kapcsolat;
